import { combineReducers } from 'redux';

import * as types from 'modules/releases/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  open: boolean,
 *  releaseId: string | null,
 *  previewMode: boolean,
 * }} ReleaseModalReducer
 */

export default combineReducers({
  open: createReducer(false, {
    [types.OPEN_RELEASE_MODAL]: () => true,
    [types.CLOSE_RELEASE_MODAL]: () => false,
  }),
  releaseId: createReducer(null, {
    [types.CLOSE_RELEASE_MODAL]: () => null,
    [types.OPEN_RELEASE_MODAL]: (_, { payload }) => payload?.releaseId ?? null,
    [types.UPDATE_RELEASE_MODAL]: (_, { payload }) => payload?.releaseId ?? null,
  }),
  previewMode: createReducer(null, {
    [types.CLOSE_RELEASE_MODAL]: () => false,
    [types.OPEN_RELEASE_MODAL]: (_, { payload }) => payload?.previewMode ?? false,
  }),
});
